import { Injectable } from "@angular/core";
import { Subject, BehaviorSubject } from "rxjs";
import { Plant } from "src/model/class/general classes/plant";
import { ListSelectable } from "src/model/class/general classes/list-selectable";
import { iMedia } from "src/model/interface/iMedia";
import { Filter } from "src/components/shared-components/class/general-classes/filter";
import { TreeNode } from "src/model/class/general classes/tree-node";
import { subscribeOn } from "rxjs/operators";
import { Environment } from "src/components/shared-components/class/general-classes/environment";
import { Card } from "src/model/class/general classes/card";
import { CardEnvironment } from "src/model/class/general classes/card-environment";

@Injectable({
  providedIn: "root",
})
export class EventService {
  OnSelectedPlantEdit = new Subject();
  OnDeletePlantOnSmartphone = new Subject();
  OnSelectPlantShowLoginForm = new Subject();

  /** Propagate event associated with the return to the "initial" composition of home.page (ValueTab == 1)
   * from another composition (firstly, the "login-form" in login-access-plant).
   *
   * Reactions from this event should include:
   *
   * 1)Stop of polling-cycle.
   *
   * 2)Deselection of the currently selected plant.
   *
   * NOTE: We put the deselection of the currently selected plant in "Network.service"'s subsrcription to this Subject, since
   * this causes the ARREST OF THE POLLING-CYCLE.*/
  OnComebackToPlantList = new Subject();

  /**
   *  Propagate event associated with the return to the connection-settings page related to the currently selected plant.
   *
   * NOTE: Reactions of this event SHOULD NOT include deselection the currently selected plant.//
   */
  OnComebackToPlantSettings = new Subject();

  /**
   * Signals the END of the loggin-in process.
   * */
  OnLoginPlantDid = new Subject();

  /**
   * Signal the start of the process of logging out.
   */
  OnMakeLogout = new Subject();
  /**
   * Signal the end of the logout: the pages of the reserved area are destroyed and have released their MQTT topics.
   */
  OnLogoutCompleted = new Subject<void>();
  /**
   * Signal globally if the app's initialisation process is ended.
   */
  OnAppInitialisationCompleted: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);

  OnQRPlantScanned = new Subject<Plant>();
  OnBackSchedule = new Subject();

  OnChargeSupervisionList = new Subject();

  /** Handle wan block response received after login operation */
  OnPlantReceivedWanBlockResponse = new Subject<boolean>();

  onComeBacktoScheduleList = new Subject();

  /**Force request of logout */
  OnMakeForceLogout = new Subject();

  //#region Scenario
  /** Fire scenarios generic update */
  OnScenarioChange = new Subject<any>();
  OnScenarioScheduleChange = new Subject<any>();
  //#endregion

  //#region Schedule
  /** Fire schedules generic update */
  OnScheduleChange = new Subject<any>();
  OnScheduleCalendarChange = new Subject<any>();
  OnScheduleNotificationChange = new Subject<any>();
  //#endregion

  //#region ReportHTML
  /** Fire ReportHTML generic update */
  OnReportHTMLChange = new Subject<any>();
  //#endregion

  //#region AccountingEntities
  /** Fire AccountingEntities generic update */
  OnAccountingEntitiesChange = new Subject<any>();
  //#endregion

  //#region WeeklyPlanning
  OnweeklyPlanningChange = new Subject<any>();
  OnReloadWeeklyPlanning = new Subject<void>();
  //#endregion

  //#region ControlGroup
  OncontrolGroupChange = new Subject<any>();
  //#endregion

  //#region Smart component
  OnSmartComponentChange = new Subject<any>();
  //#endregion

  //#region AddressesForward
  OnAddressesForwardChange = new Subject<any>();
  //#endregion

  //#region Calendar
  /** Fire calendars generic update */
  OnCalendarsChange = new Subject<any>();
  //#endregion

  //#region Notification
  /** Fire notifications generic update */
  OnNotificationsChange = new Subject<Array<string>>();
  //#endregion

  //#region Generic List Selectable Event Item

  /**Propagate Scenario assign/disassign to object (Schedule, logic ....) */
  OnAssignDisassignScenarioToGenericObjectEvent = new Subject<ListSelectable>();

  /**Propagate notification assign/disassign to generic logic */
  OnAssignDisassignNotificationToGenericObjectEvent =
    new Subject<ListSelectable>();

  /** Propagate calendar assign/disassign to generic object */
  OnAssignDisassignCalendarToGenericObjectEvent = new Subject<ListSelectable>();
  //#endregion

  //#region Media

  /**Propagate on uploading media (sound, image...etc) pending */
  OnMediaUploadInProgressEvent = new Subject<number>();

  /**Propagate on uploading media (sound, image...etc) is completed */
  OnMediaUploadComplete = new Subject<iMedia>();

  /**Propagate on uploading media (sound, image...etc) is aborted */
  OnMediaUploadAbort = new Subject<iMedia>();

  /**Propagate on import ETS project pending */
  OnETSImportInProgressEvent = new Subject<number>();
  /**Propagate on import ETS project is completed */
  OnETSImportComplete = new Subject<any>();
  /**Propagate on import ETS project is aborted */
  OnETSImportAbort = new Subject<any>();

  //#endregion

  //Handle exit from kiosk mode
  OnKioskModeExit = new Subject();

  /**AB when the root is changed */
  OnServerRootChanged = new Subject();

  OnCustomInterfaceChanged = new Subject<any>();
  OnCustomInterfaceDeleted = new Subject<any>();

  /**AB when application come back online after beeing offline */
  OnComeBackOnline = new Subject<any>();
  OnComeBackOnlineMqtt = new Subject<any>();
  /** Handle request external disconnect inside MQTT service */
  OnRequestDisconnectMqtt = new Subject<any>();
  OnComeBackOfflineMqtt = new Subject<any>();
  OnCustomInterfaceChangedMqtt = new Subject<any>();

  OnSupervisionListChangeMqtt = new Subject<any>();

  OnReloadBackgroundSupervision = new Subject<any>();
  OnSupervisionRestoreDefualtOrder = new Subject<number>();

  OnCordovaIsReadyToRumble = new BehaviorSubject<boolean>(false);
  OnIsAndroidDevice = new BehaviorSubject<boolean>(false);

  /**Emit when a generic "external" change (IE. a change caused by another application) has been applied to the customer/staff list */
  OnCustomerStaffChanged = new Subject<any>();

  /**Emit when a generic "internal" change (IE. a change caused by this application) has been applied to the customer/staff list */
  //OnCustomerStaffChangedLocally = new Subject<number>();

  /**Emit when a specific change on the image associated is applied on a customer/staff entity */
  OnPropagatePhotoChanged = new Subject<any>();

  /**Emit when  a customer/staff entity is deleted*/
  OnCustomerStaffDeleted = new Subject<any>();

  OnBeReadyToGetCards = new Subject<any>();

  OnForceCloseAnagraphPanel = new Subject<boolean>();

  OnFilterValueChanged = new Subject<[Filter, string]>();

  /**Handle virtual access propagation component*/
  OnVirtualAccessComponentLocked = new Subject<boolean>();

  /** Handle feedback on request open door*/
  OnRequestOpenDoorFeedbackReceived = new Subject<number>();

  OnLanguageChanged = new Subject();

  /** Used to closing loader preventing CD dependency*/
  OnRequestClosingLoader = new Subject();

  /**Signal to single contained-items if their container-list is scrolling*/
  OnListIsScrolling = new BehaviorSubject<boolean>(false);

  /** Send event to change configuration page*/
  OnGatewayConfigurationPageChange = new Subject<number>();

  /** When click on a node of the building tree */
  OnGatewayBuildingNodeSelected = new Subject<TreeNode[]>();

  /** Send event to change name on tree */
  OnGatewayBuildingNodeInfoChanged = new Subject<TreeNode>();

  /** Send event to delete node of tree */
  OnGatewayBuildingNodeDeleted = new Subject<TreeNode[]>();

  /** Send event when we want to change the building view */
  OnGatewayBuildingViewChanged = new Subject<boolean>();

  /** Send event when a new node must be added to the tree: contains the parent node and the new child node */
  OnGatewayBuildingNodeAdded = new Subject<TreeNode[]>();

  /** Used to pass data to the mad configuration popup */
  OnGatewayBuildingMADConfig = new Subject<Environment[]>();

  /** Send event on card changed generic */
  OnCardChanged = new Subject<Card>();

  /** Send event on card changed generic */
  OnCardCreated = new Subject<Card>();

  /** Send event on card environment changed generic */
  OnCardEnvironmentChanged = new Subject<CardEnvironment>();

  /**Send event on card remotion */
  OnCardRemoved = new Subject<Card>();

  /**Send event on select equipment */
  onSelectEquipments = new Subject<Array<any>>();

  /** Send event on select an equipment property */
  onSelectEquipmentProperty = new Subject<any>();

  /** Send event on deselecting all equipment id's */
  onDeselectAllEquipmentId = new Subject<boolean>();

  /** Send event on select an equipment property id */
  onSelectEquipmentId = new Subject<boolean>();

  /**Send event to all existing "ErrorContent" inside a page when that page is being abandoned.
   * If the components have to be destroyed, it sends a TRUE value, Otherwise, FALSE.
   */
  OnErrorContentPageLeaving = new Subject<boolean>();

  /**
   * Send event on click device to open an actionsheet
   */
  onClickDeviceActionSheet = new BehaviorSubject<number>(null);

  /**
   * Send event on saved equipment properties
   */
  onSaveEquipmentProperties = new BehaviorSubject<boolean>(false);

  constructor() { }
}
